
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';
import {OrderInfo} from './OrderInfo';
import {FieldModelOrderInfo} from './OrderInfo';

/**
 * OrderCloseByResponse struct
 */
class OrderCloseByResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!OrderInfo=} closedOrder
   * @param {!OrderInfo=} closedByOrder
   * @param {OrderInfo=} remainingOrder
   * @constructor
   */
  constructor (parent = new Response(), closedOrder = new OrderInfo(), closedByOrder = new OrderInfo(), remainingOrder = null) {
    super()
    super.copy(parent)
    this.ClosedOrder = closedOrder
    this.ClosedByOrder = closedByOrder
    this.RemainingOrder = remainingOrder
  }

  /**
   * Copy struct (shallow copy)
   * @this {!OrderCloseByResponse}
   * @param {!OrderCloseByResponse} other Other struct
   * @returns {!OrderCloseByResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.ClosedOrder != null) {
      this.ClosedOrder = OrderInfo.fromObject(other.ClosedOrder)
    } else {
      this.ClosedOrder = null
    }
    if (other.ClosedByOrder != null) {
      this.ClosedByOrder = OrderInfo.fromObject(other.ClosedByOrder)
    } else {
      this.ClosedByOrder = null
    }
    if (other.RemainingOrder != null) {
      this.RemainingOrder = OrderInfo.fromObject(other.RemainingOrder)
    } else {
      this.RemainingOrder = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!OrderCloseByResponse}
   * @returns {!OrderCloseByResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new OrderCloseByResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new OrderCloseByResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!OrderCloseByResponse}
   * @param {!OrderCloseByResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrderCloseByResponse)) {
      throw new TypeError('Instance of OrderCloseByResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!OrderCloseByResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      ClosedOrder: ((this.ClosedOrder != null) ? this.ClosedOrder : null),
      ClosedByOrder: ((this.ClosedByOrder != null) ? this.ClosedByOrder : null),
      RemainingOrder: ((this.RemainingOrder != null) ? this.RemainingOrder : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return OrderCloseByResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!OrderCloseByResponse} other Object value
   * @returns {!OrderCloseByResponse} Created struct
   */
  static fromObject (other) {
    return new OrderCloseByResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!OrderCloseByResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return OrderCloseByResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!OrderCloseByResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5103
  }
}

export { OrderCloseByResponse };

/**
 * Fast Binary Encoding OrderCloseByResponse field model
 */
class FieldModelOrderCloseByResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.ClosedOrder = new FieldModelOrderInfo(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.ClosedByOrder = new FieldModelOrderInfo(buffer, this.ClosedOrder.fbeOffset + this.ClosedOrder.fbeSize)
    this.RemainingOrder = new fbe.FieldModelOptional(new FieldModelOrderInfo(buffer, this.ClosedByOrder.fbeOffset + this.ClosedByOrder.fbeSize), buffer, this.ClosedByOrder.fbeOffset + this.ClosedByOrder.fbeSize)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelOrderCloseByResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelOrderCloseByResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelOrderCloseByResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.ClosedOrder.fbeSize + this.ClosedByOrder.fbeSize + this.RemainingOrder.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelOrderCloseByResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.ClosedOrder.fbeExtra + this.ClosedByOrder.fbeExtra + this.RemainingOrder.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelOrderCloseByResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelOrderCloseByResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelOrderCloseByResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5103
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelOrderCloseByResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelOrderCloseByResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.ClosedOrder.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ClosedOrder.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClosedOrder.fbeSize

    if ((fbeCurrentSize + this.ClosedByOrder.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ClosedByOrder.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClosedByOrder.fbeSize

    if ((fbeCurrentSize + this.RemainingOrder.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RemainingOrder.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RemainingOrder.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelOrderCloseByResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelOrderCloseByResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelOrderCloseByResponse}
   * @param {!OrderCloseByResponse} fbeValue Default value, defaults is new OrderCloseByResponse()
   * @returns {!OrderCloseByResponse} OrderCloseByResponse value
   */
  get (fbeValue = new OrderCloseByResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelOrderCloseByResponse}
   * @param {!OrderCloseByResponse} fbeValue OrderCloseByResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.ClosedOrder.fbeSize) <= fbeStructSize) {
      fbeValue.ClosedOrder = this.ClosedOrder.get()
    } else {
      fbeValue.ClosedOrder = new OrderInfo()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClosedOrder.fbeSize

    if ((fbeCurrentSize + this.ClosedByOrder.fbeSize) <= fbeStructSize) {
      fbeValue.ClosedByOrder = this.ClosedByOrder.get()
    } else {
      fbeValue.ClosedByOrder = new OrderInfo()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClosedByOrder.fbeSize

    if ((fbeCurrentSize + this.RemainingOrder.fbeSize) <= fbeStructSize) {
      fbeValue.RemainingOrder = this.RemainingOrder.get()
    } else {
      fbeValue.RemainingOrder = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RemainingOrder.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelOrderCloseByResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelOrderCloseByResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelOrderCloseByResponse}
   * @param {!OrderCloseByResponse} fbeValue OrderCloseByResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelOrderCloseByResponse}
   * @param {OrderCloseByResponse} fbeValue OrderCloseByResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.ClosedOrder.set(fbeValue.ClosedOrder)
    this.ClosedByOrder.set(fbeValue.ClosedByOrder)
    this.RemainingOrder.set(fbeValue.RemainingOrder)
  }
}

export { FieldModelOrderCloseByResponse };

/**
 * Fast Binary Encoding OrderCloseByResponse model
 */
class OrderCloseByResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelOrderCloseByResponse(this.buffer, 4)
  }

  /**
   * Get the OrderCloseByResponse model
   * @this {!OrderCloseByResponseModel}
   * @returns {!FieldModelOrderCloseByResponse} model OrderCloseByResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!OrderCloseByResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!OrderCloseByResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return OrderCloseByResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!OrderCloseByResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelOrderCloseByResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!OrderCloseByResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!OrderCloseByResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!OrderCloseByResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!OrderCloseByResponseModel}
   * @param {!OrderCloseByResponse} value OrderCloseByResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!OrderCloseByResponseModel}
   * @param {!OrderCloseByResponse} value OrderCloseByResponse value, defaults is new OrderCloseByResponse()
   * @return {!object} Deserialized OrderCloseByResponse value and its size
   */
  deserialize (value = new OrderCloseByResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new OrderCloseByResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new OrderCloseByResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!OrderCloseByResponseModel}
   * @param {!number} prev Previous OrderCloseByResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { OrderCloseByResponseModel };
